export const customerPaymentSection = '/pay';

export const customerPaymentPath = customerPaymentSection + '/:accessKey';
export const customerPaymentSuccessPath = customerPaymentSection + '/:accessKey/success';
export const customerPaymentProcessingPath = customerPaymentSection + '/:accessKey/processing';
export const customerPaymentPendingActionPath = customerPaymentSection + '/:accessKey/pending-action';

/** Public QuickPay customer flow (must match navigations from Stripe). */
export const quickPayCustomerPaymentSection = '/quick-pay-payment';

export const quickPayCustomerPaymentPath = `${quickPayCustomerPaymentSection}/:accessKey`;
/** Apple/Google Pay redirect lands here first; then we navigate to success with the Stripe PaymentIntent id. */
export const quickPayCustomerPaymentWalletReturnPath = quickPayCustomerPaymentPath + '/wallet-return';
/** Success URL is canonicalized to internal payment id. */
export const quickPayCustomerPaymentSuccessPath =
  quickPayCustomerPaymentPath + '/:paymentId/success';
export const quickPayCustomerPaymentProcessingPath = quickPayCustomerPaymentPath + '/processing';
export const quickPayCustomerPaymentPendingActionPath = quickPayCustomerPaymentPath + '/pending-action';
